import React from 'react';
import { useManualActivityModel } from './model';
import { ManualActivityView } from './view';

export const ManualActivityWidget: React.FC = () => {
  const {
    state,
    loadOverview,
    requestNextTask,
    copyPhone,
    copyMessage,
    markSent,
    startRedemption,
    setRedemptionPhone,
    switchRedemptionAuthMethod,
    regenerateRedemptionCredential,
  } = useManualActivityModel();

  return (
    <ManualActivityView
      state={state}
      onRefresh={loadOverview}
      onNextTask={requestNextTask}
      onCopyPhone={copyPhone}
      onCopyMessage={copyMessage}
      onMarkSent={markSent}
      onStartRedemption={startRedemption}
      onRedemptionPhoneChange={setRedemptionPhone}
      onRedemptionAuthMethodChange={switchRedemptionAuthMethod}
      onRegenerateRedemptionCredential={regenerateRedemptionCredential}
    />
  );
};
